const validationConfiguration = {
  validation_configuration: "Configuración de Validación",
  validation_configuration_description:
    "Reglas de validación configurables para referencias a entidades en líneas de factura",
  save: "Guardar",
  saved_successfully: "Guardado correctamente",
  po_based_invoice: "Factura basada en orden de compra",
  delivery_note_based_invoice: "Factura basada en albarán",
  validatePurchaseOrderLineId: "Las líneas de OC son obligatorias",
  validatePurchaseOrderLineId_description:
    "El id de la línea de orden de compra debe estar presente en cada línea de artículo",
  validateDeliveryNoteLineId: "Las líneas de albarán son obligatorias",
  validateDeliveryNoteLineId_description:
    "El id de la línea de albarán debe estar presente en cada línea de artículo",
  validateGRNLineId: "Las líneas de nota de recepción son obligatorias",
  validateGRNLineId_description:
    "El id de la línea de nota de recepción de mercancías debe estar presente en cada línea de artículo",
  validateItemLineTaxId: "El impuesto de la línea de artículo es obligatorio",
  validateItemLineTaxId_description:
    "El id de impuesto debe estar presente en cada línea de artículo",
  validateTaxLineTaxId: "El impuesto de la línea de impuestos es obligatorio",
  validateTaxLineTaxId_description:
    "El id de impuesto debe estar presente en cada línea de impuestos",
  entity_validation: "Validación de entidades",
  enableCompanyEntityValidation: "Validación de entidad de empresa",
  enableCompanyEntityValidation_description:
    "Validar la referencia a la entidad de empresa del documento",
  enableSupplierEntityValidation: "Validación de entidad de proveedor",
  enableSupplierEntityValidation_description:
    "Validar la referencia a la entidad de proveedor del documento",
  enableCustomerEntityValidation: "Validación de entidad de cliente",
  enableCustomerEntityValidation_description:
    "Validar la referencia a la entidad de cliente del documento",
  validation_configuration_company_entity_validation_required:
    "La validación de entidad de empresa es obligatoria",
};

export default validationConfiguration;
